<template>
  <b-card bg-variant="light">
    <b-form-group
      label-cols-lg="3"
      label="Trial Time"
      label-size="lg"
      label-class="font-weight-bold pt-0"
      class="mb-0"
    >
      <b-form-row>
        <b-col>
          <b-form-group
            label="Select how long trial lasts:"
            label-for="trial-selecter"
          >
          </b-form-group>
          <b-form-select
            v-model="v.$model"
            :options="trialOptions"
            class="mb-3"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled id="trial-selecter"
                >-- Please select an option --</b-form-select-option
              >
            </template>
          </b-form-select>

          <span
            v-if="!v.required && v.$dirty"
            class="text-danger"
            >Required if free trial!
          </span>
        </b-col>
      </b-form-row>
    </b-form-group>
  </b-card>
</template>

<script>
// Trial Time card. Binds the trial-product selection through the `v` prop
// (parent's $v.selected_trial_time_product); the parent keeps the
// CardSelection-based v-if on the tag. Behavior is identical to the inline
// markup it replaced.
export default {
  name: "TrialCard",
  props: {
    v: { type: Object, required: true },
    trialOptions: { type: Array, required: true },
  },
};
</script>
